import React, { useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import { getLocale, useIntl } from 'umi';
import { barSIcon, lineIcon, tableIcon } from '@op/constants/chart';
import { downloadAction } from '@op/pages/download/utils';
import SortBySelect from '@op/components/FilterBoxCommon/filters/single-select-factory';
import LanguageBar from './LanguageBar';
import LanguageTable from './LanguageTable';
import './index.scss';
import LanguageLine from './LanguageLine';

interface IAllReviewsChart {
  filter: any;
  type?: string;
  height?: number;
  selectedLanguage: string;
  setSelectedLanguage: (lang: string) => void;
  data: any;
  translate: (value: string) => string;
  sortBy: string;
  setSortBy: (value: string) => void;
  timeline: { legend: Array<string>; xAxis: Array<string>; series: Array<any>;isEmpty: boolean };
  metric: string;
  setMetric: (metric: any) => void;
  isEmpty: boolean;
}

export default function AllReviewsChart(props: IAllReviewsChart) {
  const { formatMessage } = useIntl();
  const isEn = getLocale() === 'en-US';
  const [chartType, setChartType] = useState('sentiment-s-bar');
  const {
    filter,
    height = 312,
    type = 'language',
    selectedLanguage,
    setSelectedLanguage,
    data,
    translate,
    sortBy,
    setSortBy,
    timeline,
    metric,
    isEmpty,
    setMetric,
  } = props;

  return (
    <CardCommon
      operations={[barSIcon, lineIcon, tableIcon]}
      defaultOperation={chartType}
      handleOperationsOnClick={(item) => {
        setChartType(item?.symbol || 'sentiment-s-bar');
      }}
      title={
        chartType === 'line' ? (
          <SortBySelect
            defaultParams={{
              options: [
                { value: 'all_reviews', text: 'Reviews' },
                { value: 'positive', text: 'Reviews Positive%' },
              ],
              matchButtonWidth: true,
              btnTextPrefix: formatMessage({ id: 'Metric' }),
            }}
            defaultValue={metric}
            onChange={(_key: any, val: string) => {
              setMetric(val);
            }}
          />
        ) : (
          <SortBySelect
            defaultParams={{
              options: [
                { value: 'all_reviews', text: 'All Reviews' },
                { value: 'positive_reviews', text: 'All Reviews Positive%' },
                { value: 'negative_reviews', text: 'All Reviews Negative%' },
              ],
              matchButtonWidth: true,
              btnTextPrefix: isEn ? formatMessage({ id: 'Ranked By' }) : '',
              dealwithButton: (value: any, { textMap }: any) => {
                const valueText = formatMessage({ id: textMap[value] });
                return isEn
                  ? valueText
                  : formatMessage(
                      { id: 'Ranked By {value}' },
                      { value: valueText },
                    );
              },
            }}
            defaultValue={sortBy}
            onChange={(_key: any, val: string) => {
              setSortBy(val);
            }}
          />
        )
      }
      hasDownload
      contentCard
      handleDownloadOnClick={() => {
        downloadAction({
          key: 'AllReviewsSupportLanguage',
          fileName: 'All Reviews of Supported Language',
          filter,
          auxiliaryParams: {},
          data: (data?.table || []).map((item: any) => ({
            ...item,
            language: translate(item.language),
          })),
        });
      }}
      empty={chartType === "line" ? timeline.isEmpty : isEmpty}
    >
      {chartType === 'sentiment-s-bar' ? (
        <LanguageBar
          height={height + 2}
          chartData={data?.bar}
          type={type}
          translate={translate}
          setSelectedLanguage={setSelectedLanguage}
          selectedLanguage={selectedLanguage}
          sortBy={sortBy}
          setSortBy={setSortBy}
        />
      ) : chartType === 'line' ? (
        <LanguageLine
          timeline={timeline}
          metric={metric}
          height={height + 1}
          filter={filter}
          translate={translate}
        ></LanguageLine>
      ) : (
        <LanguageTable
          height={height}
          records={data?.table}
          filter={filter}
          type={type}
          translate={translate}
        />
      )}
    </CardCommon>
  );
}
